// src/services/endpoints/authEndpoints.js

import { AUTH_ENDPOINTS } from "../config/apiconfig";
import { apiSlice } from "../apiSlice";

export const authEndpoints = (builder) => ({
  login: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.LOGIN,
      method: "POST",
      data: credentials,
    }),
    async onQueryStarted(arg, { queryFulfilled }) {
      try {
        const { data } = await queryFulfilled;
        localStorage.setItem("token", data.token);
      } catch (error) {
        // console.error("Login error:", error);
      }
    },
  }),

  signup: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.REGISTER,
      method: "POST",
      data: credentials,
    }),
  }),

  verifyOTP: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.VERIFYOTP,
      method: "POST",
      data: credentials,
    }),
  }),

  resendOTP: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.RESENDOTP,
      method: "POST",
      data: credentials,
    }),
  }),

  logout: builder.mutation({
    query: () => ({
      url: AUTH_ENDPOINTS.LOGOUT,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
        localStorage.removeItem("token");
        dispatch(apiSlice.util.resetApiState());
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),
});
